<template>
  <div class="saveModal">

      <div v-if="saving" class="saveContent">
    		<div class="title"> {{ $t('saveBasket') }}</div>

    		<div class="saveForm">
          <form v-on:submit="save">
      			<label> {{ $t('name') }} </label>
      			<input v-model="name" type="text">
      			<div v-on:click="save" class="button">
      				<i v-if="saved" class="fa fa-check"></i>
      				<loader :inline="true" classes="" identifier="save"></loader>
      				{{ $t('save') }}
      			</div>
            <input type="submit" style="position: absolute; left: -9999px"/>
          </form>

    		</div> <!-- saveForm -->

      </div> <!-- saveContent -->

      <div v-if="updating" class="updateContent">

         <div class="title"> {{ $t('saveBasket') }}</div>
         <div class="message raleway"> {{ $t('updateOrnew', { name: currentName }) }} </div>

         <form v-on:submit="updateSave">
           <div class="updateName">
             <input id="updateName" type="text" >
           </div>

           <div class="updateButtons text-center">
            <div v-on:click="updateSave" class="button">
              <i v-if="saved" class="fa fa-check"></i>
              <loader :inline="true" classes="" identifier="save"></loader> {{ $t('update') }}
            </div>
            <div v-on:click="showSave" class="button"> {{ $t('createNew') }}  </div>
          </div>

          <input type="submit" style="position: absolute; left: -9999px"/>
        </form>
      </div>

  </div> <!-- saveModal -->
</template>

<script>

export default {
  data: function(){
    return{
    	name: '',
    	saved: false,
      saving: false,
      updating: false,
      newName: "",
      currentName: false,
    }
  },

  props: ['listData'],

  computed: {

  	price(){
      return this.$store.state.price;
    },

    isOwner(){
      return this.$store.state.isOwner;
    },

  },

  methods: {

  	save: function(e){

  		var self = this;

      // Start loading
      self.$store.commit('startLoading', 'save');

      this.createImage(function(response){

          // Save and pass data
          window.apiHandler.save(function(data){

            if(data.status){

              // If everything was successful
              self.saved = true;
              self.$store.commit('updated', false)

              // Send event
              self.trackEvent('saved a wall');

              // Close after 1 second
              setTimeout(function(){
                window.eventHub.$emit('closeModal');
              }, 900);

            }
            // If error occured
            else{
              alert("An unepected problem occured, please try again later or contact support.")
            }

          },{
            name: self.name,
            picture: response.filename
          });

      }, function(){

        // Could not save right now
        self.$store.commit('stopLoading', 'save');

      })

      e.preventDefault();
      return false;

  	},

    updateSave: function(e){

      var self = this;

      // Start loading
      self.$store.commit('startLoading', 'save');

      self.createImage(function(response){

          // Save and pass data
          window.apiHandler.updateSave(function(data){

            if(data.status){

              // If everything was successful
              self.saved = true;
              self.$store.commit('updated', false)

              // Close after 1 second
              setTimeout(function(){
                window.eventHub.$emit('closeModal');
              }, 900);

            }
            // If error occured
            else{
              alert("An unepected problem occured, please try again later or contact support.")
            }

          },{
            name: $("#updateName").val(),
            picture: response.filename
          });

      })

      e.preventDefault();
      return false;

    },

    showSave(){
      this.updating = false;
      this.saving = true;
    },

  	buy: function(){
      window.apiHandler.buy(function(data){});
    },

  },

  mounted: function () {

    var self = this;

    // Decide if saving or updating
    if(self.$store.state.currentWallID && self.isOwner)
    {

      self.updating = true;
      window.vueRender(function(){
        self.currentName = self.$store.state.currentWallName;
        $("#updateName").val(self.$store.state.currentWallName);
      })

    }
    else
    {
      this.saving = true;
    }

  }

}
</script>

<style>
.saveModal{

	.saveForm{

		  max-width: 80%;
	    margin: auto;
	    padding: 18px 0;

	    label{
	    	text-align: left;
		    font-size: 13px;
		    font-weight: normal;
	    }

	    input{
	    	width: 72%;
	    	margin: 0px;
	    }

	    .button{
  			margin: 0px;
  			display: inline-block;
  			width: 27%;
  			position: relative;
  			top: -2px;
        padding: 0;
		  }

      /* Mobile */
      @media screen and (max-width: 812px) {

        input{
          width: 100% ;
        }

        .button{
          display: block;
          margin: auto;
          margin-top: 15px;
          width: 35%;
        }


      }

	}

  .updateName{
    width: auto;
    text-align: center;
    max-width: 267px;
    margin: 10px auto -15px auto;


    input{
      width: 100%;
    }
  }

  .message{
    margin-top: 25px;
    text-align: center;
    font-size: 13px;
    text-transform: uppercase;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    line-height: 26px;
  }

  .updateButtons{
    margin-top: 20px;
  }


}

</style>



// WEBPACK FOOTER //
// Save.vue?93311286